import { gql } from '@apollo/client';

const GET_SELECTED_ORG_FOR_EVENT = gql`
  query GetSelectedOrgForEvent($eventId: Int!, $includeSelectedUnitsOnly: Boolean) {
    getSelectedOrgForEvent(eventId: $eventId, includeSelectedUnitsOnly: $includeSelectedUnitsOnly) {
      Id
      Name
      MddapOrgUnits {
        Id
        Name
        Fei
        IsActive
      }
    }
  }
`;

export default GET_SELECTED_ORG_FOR_EVENT;
